export default __webpack_public_path__ + "static/media/xtreme-project-2.3f7e61eb.webp";